$(document).ready(function name(params) {
  
  $("#CartSpecialInstructions_drawer").keyup(function(){
    var thisVal = $(this).val();
    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      data: {note: thisVal},
      success: function(result) { 
         // console.log("result");
      },
      error: function(jqxhr, status, exception) {
          console.log(exception);
      } 
    });
  });  
})
 

  $(document).on("click", ".cdk_wishlist__block .cdk-wishlist .button_text", function(){
    if ($(this).text() == "Favoriet")
         $(this).text("verwijder")
    else
         $(this).text("Favoriet");
  });

//wishlist
function clean_value(data){
  data = $.trim(data);
  return data;
}
function update_wishlist_product_icon(){
  var cd_myWhishlist = clean_value( localStorage.getItem("cd_myWhishlist") ); 
  if(cd_myWhishlist != null && cd_myWhishlist != ''){
    var valueArrayWhishlist = cd_myWhishlist.split(','); 
    // console.log('valueArrayWhishlist :: '+valueArrayWhishlist);
    $('.cdk_wishlist__block .cdk-wishlist').each(function(){
      var productTitle = clean_value( $(this).attr('product-title') );
      var productid = clean_value( $(this).attr('product-id') );
      if(productTitle != '' && $.inArray(productTitle, valueArrayWhishlist ) > -1){
        $(this).toggleClass('productAdded');
        if ($(this).hasClass('productAdded')) {
          $(this).children('.button_text').text("verwijder");
        }
        else {
          $(this).children('.button_text').text("Favoriet"); 
        }
      }
      
    })
  }
}
function loading_dots(){
var dotNum = parseInt($('#wishlist__product_container .dots__loading').attr('data-dot-num')); 
if(typeof dotNum == 'undefined'){
  var setDots = '...' ; var dotNum = '3';
}
else if(dotNum == 3){
  var setDots = '.' ; var dotNum = '1';
}
else if(dotNum == 1){
  var setDots = '..' ; var dotNum = '2';
}
else if(dotNum == 2){
  var setDots = '...' ; var dotNum = '3';
}
else{
  var setDots = '...' ; var dotNum = '3';
}

$('#wishlist__product_container .dots__loading').html(setDots);
$('#wishlist__product_container .dots__loading').attr('data-dot-num',dotNum);
}
function loading_whishlist_product(productTitle,mywishlistLoader){
  var url = '/search?q='+productTitle ; var fillColorCode = '#1F1F1F';
  $.ajax({
    url: url,
    type: "get",
    dataType: "html",
    success: function(htmlData) {
      clearInterval(mywishlistLoader);
      if( $('#wishlist__product_container .dots__loading').length > 0 ){ $('#wishlist__product_container').html('');  }
      var wishlistProductHtml = $(htmlData).find('.row.search-results .col').html(); 
      $('#wishlist__product_container').append(wishlistProductHtml);
      // $('#wishlist__product_container').find('.cdk-icons.cdk-wishlist').children('svg').attr('fill',fillColorCode);
    },
    error: function(jqXHR, textStatus, errorThrown) {
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
    }
  });
}

function update_wishlist_Count(){
var cd_myWhishlistCount = clean_value( localStorage.getItem("cd_myWhishlist") );
if(cd_myWhishlistCount != ''){
  var valueArrayWhishlistCount = cd_myWhishlistCount.split(','); 
}else{
  var valueArrayWhishlistCount = '';
  localStorage.removeItem("cd_myWhishlist"); 
}
// console.log('cd_myWhishlistCount::'+cd_myWhishlistCount);
// console.log('valueArrayWhishlist::'+valueArrayWhishlistCount.length);
$('.cdk_wishlist_count').text(valueArrayWhishlistCount.length);
  if(valueArrayWhishlistCount.length == '0'){
    var noWishlistProductAlertHtml = '<div class="emptywishlist"><p class="no__Wishlist_Product__exists">Deze lijst is leeg.</p><a href="/collections/all" class="button">Shop now</a></div>';
    $('#wishlist__product_container').addClass('emptyWishlist');
    $('#wishlist__product_container').html(noWishlistProductAlertHtml);
  }
}

function update_wishlist_page(){
var mywishlistLoader = setInterval(loading_dots, 500); // clearInterval(mywishlistLoader);

var cd_myWhishlist = clean_value( localStorage.getItem("cd_myWhishlist") );
if(cd_myWhishlist != null && cd_myWhishlist != ''){
  var valueArrayWhishlist = cd_myWhishlist.split(','); 
  for(var st = 0;st < valueArrayWhishlist.length;st++){
    var productTitle = clean_value(valueArrayWhishlist[st]);
    if(productTitle != ''){ loading_whishlist_product(productTitle,mywishlistLoader); }
  }
}
else
{
  var noWishlistProductAlertHtml = '<div class="emptywishlist"><p class="no__Wishlist_Product__exists">Deze lijst is leeg.</p><a href="/collections/all" class="button">Shop now</a></div>';
  $('#wishlist__product_container').addClass('emptyWishlist');
  $('#wishlist__product_container').html(noWishlistProductAlertHtml);
}
}




$(document).ready(function(){

  $(document).on("click", "#wishlist__product_container .cdk_wishlist__block .cdk-wishlist", function(){
    var productTitle = clean_value( $(this).attr('product-title') );
    var productid = clean_value( $(this).attr('product-id') );
    // console.log('productTitle::'+ productTitle + "productid::"+ productid);
    var cd_myWhishlist = localStorage.getItem("cd_myWhishlist");
    var valueArrayWhishlist = cd_myWhishlist.split(',');
    valueArrayWhishlist.splice(valueArrayWhishlist.indexOf(productTitle),1);
    var valueArrayWhishlistToString = valueArrayWhishlist.toString();  
    localStorage.setItem("cd_myWhishlist",valueArrayWhishlistToString);
    $(this).parents('.grid-item').remove();
    update_wishlist_Count();
  });
  $(document).on("click", ".cdk_wishlist__block .cdk-wishlist", function(){
    if( $("#wishlist__product_container").length > 0 ){ return false; }
    var productTitle = clean_value( $(this).attr('product-title') );
    var productid = clean_value( $(this).attr('product-id') );
    
    var cd_myWhishlist = localStorage.getItem("cd_myWhishlist");
    if(cd_myWhishlist == null){
      if(productTitle != ''){ 
        localStorage.setItem("cd_myWhishlist",productTitle); 
        $(this).toggleClass('productAdded');
        $(this).find('.button_text').text('verwijder');
        update_wishlist_Count();
      }
    }
    else{
      var valueArrayWhishlist = cd_myWhishlist.split(',');
      if(productTitle != ''){
        var newList = cd_myWhishlist+productTitle;
        if($.inArray(productTitle, valueArrayWhishlist ) == -1){
          if(valueArrayWhishlist.length > 0){
           var newList = cd_myWhishlist+','+productTitle;
          }
          localStorage.setItem("cd_myWhishlist",newList);
          $(this).toggleClass('productAdded');
          $(this).find('.button_text').text('verwijder');
        }
        else{
          valueArrayWhishlist.splice(valueArrayWhishlist.indexOf(productTitle),1);
          var valueArrayWhishlistToString = valueArrayWhishlist.toString();  
          localStorage.setItem("cd_myWhishlist",valueArrayWhishlistToString);
          $(this).removeClass('productAdded');
          $(this).find('.button_text').text('favoriet');
          update_wishlist_Count();
        }
      }
    } 
  
  });
  update_wishlist_product_icon();
  if(window.templateSuffix == 'wishlist'){ update_wishlist_page(); }
  if( $('#wishlist__product_container').length > 0 ){ 
    update_wishlist_page();
    update_wishlist_Count();
    
  }
// end wishlist
$(document).on('click','.form-input.form-input__select .current_sort', function(){
  $(this).next('#sort-collection_list').show();
})
$(document).on('click','.cdk_sorting_block #sort-collection_list li', function(){
  var thisVAL = $(this).attr('value');
  $('#sort-collection').val(thisVAL).change();
})


$(document).mouseup(function(e){
  var container = $("#sort-collection_list");  
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){
      container.hide();
  }
});
//Product Recommendation

function updateFreeShippingBar()
{
  $.ajax({
    type: "GET",
    url: "/",
    dataType: 'html',
    success: function(data)
    {
      var miniCartHead = $(data).contents('form[data-ajax-cart-form]').find('.free_shippingBar').html();
      $('form[data-ajax-cart-form] .free_shippingBar').html(miniCartHead);
    }
  })
}

$( document ).ajaxComplete(function( event, xhr, settings,statusText ) { 
  if ( settings.url === "/cart.js" ) {
   updateFreeShippingBar()
  }else if(settings.url ===  "/cart/change.js"){
    updateFreeShippingBar();
    var qtyUpdate = $('.cdk-qty-update').text();
    if(qtyUpdate == '0'){
      $('.cart-buttons').addClass('button-disabled');
    }
    if (xhr.status === 422) {
        alert("Sorry, er is niet genoeg voorraad om dit artikel aan uw winkelwagen toe te voegen.");
    }
  }else if(settings.url ===  "/cart/add.js"){
    updateFreeShippingBar()
  }
});
  const cdk_slider = new Swiper('.cdk-slider', {
  // Default parameters
  "slidesPerView": 4,
  "spaceBetween": 15,
  "centeredSlides": false,
  "centerInsufficientSlides": false,
  "shortSwipes": true,
  "scrollbar": false,
  "pagination": false,
  "roundLengths": true,
  "breakpointsInverse": true, 
    navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  "breakpoints": {
          "320": {
            "slidesPerView": 1.6
          },
          "768": {
            "slidesPerView": 1.6
          },
          "1024": {
            "slidesPerView": 4
          }
    }
})
  
})

/*************term & condition cheched****************/
// $(document).ready(function () {
//   $('.cdk-custom-checkout').click(function (event) {
//     event.preventDefault();
//     if ($('.check-box_condition #term-and-condition').prop('checked')) {
//           window.location = '/checkout'; 
//      }
//     else{
//       $('.check-box_condition  .cdk-form--error').show();
//     }
//   })
// });


// product page icon with text slider
$(document).ready(function(){
  $('.icon-with-text-slider').slick({
      autoplay: true,         
      autoplaySpeed: 0,      
      speed: 4000,            
      cssEase: 'linear',      
      slidesToShow: 5,        
      slidesToScroll: 1,     
      centerMode: true,       
      focusOnSelect: true,     
      infinite: true ,
      arrows: false,
      dots: false,
      pauseOnHover:false,
       responsive: [
        {
          breakpoint: 991, // Adjust as needed
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767, // Adjust as needed
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
         {
          breakpoint: 576, // Adjust as needed
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1
          }
        }
      ]
    });
  $(window).on("resize", function() {
    $(".icon-with-text-slider").slick("resize")
  });

  // COLOR SAMPLE //
  
  $(window).scroll(function(){
  if ($(window).scrollTop() >= 400) {
      $('.material-cart').addClass('show');
  }
  else {
      $('.material-cart').removeClass('show');
  }
  });

  $('.material-form-close, .popup-overlay').on('click', function () {
  $('#material').hide();
  $('.popup-overlay').hide();
  $('body').removeClass('overflow-hidden');
  });

  
  $('.cartform.swatch__cart__button').on('click', function () {
  $('#material').show();
  $('.popup-overlay').show();
  $('body').addClass('overflow-hidden');
  });

  var items = 0;
  let index
  $('.swatch__collection__content__button').each(function () {
    var $this = $(this);
    $this.on("click", function (e) {
      const number_index = items + 1;
      e.preventDefault();
      //  $this.toggleClass('active');
      var colId = $(this).parents('.materialproduct').attr("col-id");
      var pname = $(this).parents('.materialproduct').attr("data-title");
      var dataId = $(this).parents('.materialproduct').attr("data-id");
      var dataimg = $(this).parents('.materialproduct').attr("data-img");
      var productimg = '<li class="active" id="' + dataId + '"><img src="' + dataimg + '"><h2 class="col-title">' + colId + '</h2><h4 class="product-name">' + pname + '</h4><button name="add" class="btn btn--full btn--transparent swatch__collection__content__button"><div class="swatch__collection__content__button__text remove__text"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M7.125 0.875L0.875 7.125L7.125 0.875ZM0.875 0.875L7.125 7.125L0.875 0.875Z" fill="#D4DEDB"/><path d="M7.125 0.875L0.875 7.125M0.875 0.875L7.125 7.125" stroke="white" stroke-width="1.5" stroke-linecap="round"/></svg></div></button></li>'
      var Input_data = '<input type="hidden" data-id="' + dataId + '" value="Variant ID: ' + dataId + ' / Variant Name: ' + pname + '" name="contact[Selected swatches'+ number_index +']" class="cdk_swatches_value">'
      $('.mini-cart_count').html(items);
      console.log(items);
      if ( items <= 4 ) {
          if ( $(this).parents('.materialproduct').hasClass("active") ) {
              --items;
              $('.mini-cart_count').html(items);
              $(this).parents('.materialproduct').removeClass('active');
              $('.mini-cart_content-wrapper #list-item li').each(function () {
                  var compareid = $(this).attr('id');
                console.log('dataId::'+dataId +''+ 'compareid::'+compareid);
                  if ( compareid == dataId ) {
                      $(this).remove();
                  }
                  var $this = $(this);
              });
              $('#swatches-item li').each(function () {
                  var compareid = $(this).attr('id');
                  if ( compareid == dataId ) {
                      $(this).remove();
                  }
                  var $this = $(this);
              });
            
              $('#data_value_hidden input').each(function () {
                  var compareid = $(this).attr('data-id');
                  if ( compareid == dataId ) {
                      $(this).remove();
                  }
                  var $this = $(this);
              });
            
          } else {
              $(this).parents('.materialproduct').addClass('active');
              //$(this).find(".swatch__collection__content__button__text.remove__text").hide();
              items++;
              $('.mini-cart_count').html(items);
              $("#list-item").prepend(productimg);
              $("#swatches-item").prepend(productimg);
              $('#data_value_hidden').append(Input_data);
            $('.material-cart').addClass('show');
          }
      } else {
        if ( $(this).parents('.materialproduct').hasClass("active") ) {
            --items;
            $('.mini-cart_count').html(items);
            $(this).parents('.materialproduct').removeClass('active');
            $('.mini-cart_content-wrapper #list-item li').each(function () {
                var compareid = $(this).attr('id');
                if ( compareid == dataId ) {
                    $(this).remove();
                }
                var $this = $(this);
                // $(this).remove();
                // alert( $(this).attr('id') );
            });
             // $('#remove-me').remove()
            $('#swatches-item li').each(function () {
                var compareid = $(this).attr('id');
                if ( compareid == dataId ) {
                    $(this).remove();
                }
                var $this = $(this);
            });
            
              $('#data_value_hidden input').each(function () {
                  var compareid = $(this).attr('data-id');
                  if ( compareid == dataId ) {
                      $(this).remove();
                  }
                  var $this = $(this);
              });
        }
        else {
            $("#dialog").show();
        }
      }    
    });
  });
 
  
  $('.closePop').click(function(){
    $('#dialog').hide();
  });
  $('a[href="#design-advisor"]').click(function(e){
    e.preventDefault();
    $('#design-consulant-popup').show();
  });
  $(document).on("click", ".mini-cart_items li button",function () {
    var compareId = $(this).parent('.mini-cart_items li').attr('id'); 
    console.log('compareId::'+compareId);
    $('.materialproduct').each(function () {
      var materalId = $(this).attr('data-id'); 
       console.log('materalId::'+materalId);
      if ( materalId ==  compareId) {
         $(this).children('.swatch__collection__content__button').click();
      }
    });
  }); 
  $(document).on("click", ".mini-cart_items_Show-hide",function () {
       $(this).toggleClass('active');
    $(this).next('.mini-cart_content-wrapper').toggleClass('show');
  });

  $(window).scroll(function() {
    var sticky = $('.material-cart')
    if($(window).scrollTop() + $(window).height() > $(document).height() - 500){
         sticky.addClass("stickyHide");
     }else {
      sticky.removeClass("stickyHide");
    }
  });
  
 
  $(document).on("click", ".image-zoom-wrapper", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var main_image = $(this).parents(".swatch__imag").attr("data_image");
    $(".zoomed_image").attr("src", main_image);
    $(".image_zoom_wrapper").show();
  });

  $(document).on("click", ".close_zoom_wrapper", function () {
    $(".zoomed_image").attr("src", "");
    $(".image_zoom_wrapper").hide();
  });

  $(document).mouseup(function(e){
    var zooM = $(".zoom_wrapper");
    if(!zooM.is(e.target) && zooM.has(e.target).length === 0){
      $(".zoomed_image").attr("src", "");
      $(".image_zoom_wrapper").hide();
    }
  });

  $(document).mouseup(function(e){
    var dialog = $(".dialog-wrapper");
    if(!dialog.is(e.target) && dialog.has(e.target).length === 0){
      $('#dialog').hide();
    }
  });
  
  // END COLOR SAMPLE //
  
  $(document).on("click", ".faq__question[cdk-data-collapsible-parent]", function() {
      $(this).siblings().removeClass("collapsible__is-open");
      $(this).siblings('.faq__question').find('.faq__question__text').slideUp();
      $(this).toggleClass("collapsible__is-open");
      $(this).find('.faq__question__text').slideToggle();
  });
  
  $(document).on("click", ".cdk-description .description-header", function(p) {
      p.preventDefault();
      $(this).parents('.cdk-description').siblings().removeClass("collapsible__is-open");
      $(this).parents('.cdk-description').siblings('.cdk-description').find('.description-content').slideUp();
      $(this).parents('.cdk-description').toggleClass("collapsible__is-open");
      $(this).parents('.cdk-description').find('.description-content').slideToggle();
  });
  
  $(document).on("keyup", ".form-row .search_bar", function () {
    $(this).parents('.form-row').find(".search-button").css("display","none");
    $(this).parents('.form-row').find(".form-input__text").find(".search_clear").css("display","block");
    if ($(this).val() === '' || $(this).val() === null) {
        console.log('click');
        setTimeout(function() {
          $(".form-row").find(".search_clear").click();
        }, 600);
    }
  });
  
   $(document).on("click", ".search_clear", function () {
    $(this).parent(".form-input__text").find(".search_bar").val('');
     $(this).parents(".form-row").find(".search-button").css("display","block");
     $(this).css("display","none");
  });  
  $(document).on("click", ".collection_description.before span", function () {
    $(this).parents('.collection_description.before').hide();
     $(this).parents('.collection_description.before').next('.collection_description.after').show();
  });
  $(document).on("click", ".collection_description.after span", function () {
    $(this).parents('.collection_description.after').hide();
     $(this).parents('.collection_description.after').prev('.collection_description.before').show();
  });
});

